import { apiRoutes } from 'config/apiRoutes'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import type { CategoriesRes } from 'features/categories/types/categories.types'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'

export const useFetchCategories = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const {
		data: categories,
		isFetching: isCategoriesLoading,
		isSuccess: isCategoriesSuccess
	} = useQuery<CategoriesRes>({
		queryKey: queryKeys.categories.list(),
		queryFn: () => axiosPrivate.get(apiRoutes.categories('')),
		enabled: !!auth.accessToken
	})

	return {
		categories,
		isCategoriesLoading,
		isCategoriesSuccess
	}
}
